// Updated utility function for resizing images with a configurable max size
export const resizeImage = (file, maxSize = 1000) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const MAX_SIZE = maxSize;
          let width = img.width;
          let height = img.height;
  
          // Calculate new dimensions
          if (width > height && width > MAX_SIZE) {
            // Width is larger and exceeds limit
            height = Math.round((height * MAX_SIZE) / width);
            width = MAX_SIZE;
          } else if (height > MAX_SIZE) {
            // Height is larger/equal and exceeds limit
            width = Math.round((width * MAX_SIZE) / height);
            height = MAX_SIZE;
          }
  
          // Only resize if needed
          if (width === img.width && height === img.height) {
            resolve(file); // Return original file if no resize needed
            return;
          }
  
          // Create canvas for resizing
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
  
          // Convert to blob
          canvas.toBlob(
            (blob) => {
              // Create new file from blob with same name
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified,
              });
              resolve(resizedFile);
            },
            file.type,
            0.9 // Quality
          );
        };
        img.src = event.target.result;
        // Fix the error in this line - there was a stray "le);" at the end
        img.onerror = () =>
          reject(new Error("Failed to load image for resizing"));
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(file);
    });
  };